const state = {
    suppliers: [],
    supplier: {},
    error: null
};

export default state;
